/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * PaymentGatewayProxy.Api | v1
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  LinkedApiRequestDto,
  PagedResultOfWebhookEventSummaryDto,
  PortalWebhooksGetPortalWebhooksEventsParams,
  WebhookDeliveryDto,
  WebhookEventDetailDto,
} from '.././schemas';

import { apiFetcher } from '../../http/apiFetcher';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const portalWebhooksGetPortalWebhooksEvents = (
  params?: PortalWebhooksGetPortalWebhooksEventsParams,
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<PagedResultOfWebhookEventSummaryDto>(
    { url: `/portal/webhooks/events`, method: 'GET', params, signal },
    options,
  );
};

export const getPortalWebhooksGetPortalWebhooksEventsQueryKey = (
  params?: PortalWebhooksGetPortalWebhooksEventsParams,
) => {
  return [`/portal/webhooks/events`, ...(params ? [params] : [])] as const;
};

export const getPortalWebhooksGetPortalWebhooksEventsQueryOptions = <
  TData = Awaited<ReturnType<typeof portalWebhooksGetPortalWebhooksEvents>>,
  TError = unknown,
>(
  params?: PortalWebhooksGetPortalWebhooksEventsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof portalWebhooksGetPortalWebhooksEvents>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPortalWebhooksGetPortalWebhooksEventsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof portalWebhooksGetPortalWebhooksEvents>>
  > = ({ signal }) => portalWebhooksGetPortalWebhooksEvents(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof portalWebhooksGetPortalWebhooksEvents>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PortalWebhooksGetPortalWebhooksEventsQueryResult = NonNullable<
  Awaited<ReturnType<typeof portalWebhooksGetPortalWebhooksEvents>>
>;
export type PortalWebhooksGetPortalWebhooksEventsQueryError = unknown;

export function usePortalWebhooksGetPortalWebhooksEvents<
  TData = Awaited<ReturnType<typeof portalWebhooksGetPortalWebhooksEvents>>,
  TError = unknown,
>(
  params: undefined | PortalWebhooksGetPortalWebhooksEventsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof portalWebhooksGetPortalWebhooksEvents>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof portalWebhooksGetPortalWebhooksEvents>>,
          TError,
          Awaited<ReturnType<typeof portalWebhooksGetPortalWebhooksEvents>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePortalWebhooksGetPortalWebhooksEvents<
  TData = Awaited<ReturnType<typeof portalWebhooksGetPortalWebhooksEvents>>,
  TError = unknown,
>(
  params?: PortalWebhooksGetPortalWebhooksEventsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof portalWebhooksGetPortalWebhooksEvents>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof portalWebhooksGetPortalWebhooksEvents>>,
          TError,
          Awaited<ReturnType<typeof portalWebhooksGetPortalWebhooksEvents>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePortalWebhooksGetPortalWebhooksEvents<
  TData = Awaited<ReturnType<typeof portalWebhooksGetPortalWebhooksEvents>>,
  TError = unknown,
>(
  params?: PortalWebhooksGetPortalWebhooksEventsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof portalWebhooksGetPortalWebhooksEvents>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function usePortalWebhooksGetPortalWebhooksEvents<
  TData = Awaited<ReturnType<typeof portalWebhooksGetPortalWebhooksEvents>>,
  TError = unknown,
>(
  params?: PortalWebhooksGetPortalWebhooksEventsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof portalWebhooksGetPortalWebhooksEvents>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPortalWebhooksGetPortalWebhooksEventsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const portalWebhooksGetPortalWebhooksEventsIdGuid = (
  id: string,
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<WebhookEventDetailDto>(
    { url: `/portal/webhooks/events/${id}`, method: 'GET', signal },
    options,
  );
};

export const getPortalWebhooksGetPortalWebhooksEventsIdGuidQueryKey = (id?: string) => {
  return [`/portal/webhooks/events/${id}`] as const;
};

export const getPortalWebhooksGetPortalWebhooksEventsIdGuidQueryOptions = <
  TData = Awaited<ReturnType<typeof portalWebhooksGetPortalWebhooksEventsIdGuid>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof portalWebhooksGetPortalWebhooksEventsIdGuid>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPortalWebhooksGetPortalWebhooksEventsIdGuidQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof portalWebhooksGetPortalWebhooksEventsIdGuid>>
  > = ({ signal }) => portalWebhooksGetPortalWebhooksEventsIdGuid(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof portalWebhooksGetPortalWebhooksEventsIdGuid>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PortalWebhooksGetPortalWebhooksEventsIdGuidQueryResult = NonNullable<
  Awaited<ReturnType<typeof portalWebhooksGetPortalWebhooksEventsIdGuid>>
>;
export type PortalWebhooksGetPortalWebhooksEventsIdGuidQueryError = unknown;

export function usePortalWebhooksGetPortalWebhooksEventsIdGuid<
  TData = Awaited<ReturnType<typeof portalWebhooksGetPortalWebhooksEventsIdGuid>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof portalWebhooksGetPortalWebhooksEventsIdGuid>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof portalWebhooksGetPortalWebhooksEventsIdGuid>>,
          TError,
          Awaited<ReturnType<typeof portalWebhooksGetPortalWebhooksEventsIdGuid>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePortalWebhooksGetPortalWebhooksEventsIdGuid<
  TData = Awaited<ReturnType<typeof portalWebhooksGetPortalWebhooksEventsIdGuid>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof portalWebhooksGetPortalWebhooksEventsIdGuid>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof portalWebhooksGetPortalWebhooksEventsIdGuid>>,
          TError,
          Awaited<ReturnType<typeof portalWebhooksGetPortalWebhooksEventsIdGuid>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePortalWebhooksGetPortalWebhooksEventsIdGuid<
  TData = Awaited<ReturnType<typeof portalWebhooksGetPortalWebhooksEventsIdGuid>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof portalWebhooksGetPortalWebhooksEventsIdGuid>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function usePortalWebhooksGetPortalWebhooksEventsIdGuid<
  TData = Awaited<ReturnType<typeof portalWebhooksGetPortalWebhooksEventsIdGuid>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof portalWebhooksGetPortalWebhooksEventsIdGuid>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPortalWebhooksGetPortalWebhooksEventsIdGuidQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const portalWebhooksPostPortalWebhooksDeliveriesIdGuidReplay = (
  id: string,
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<WebhookDeliveryDto>(
    { url: `/portal/webhooks/deliveries/${id}/replay`, method: 'POST', signal },
    options,
  );
};

export const getPortalWebhooksPostPortalWebhooksDeliveriesIdGuidReplayMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof portalWebhooksPostPortalWebhooksDeliveriesIdGuidReplay>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof portalWebhooksPostPortalWebhooksDeliveriesIdGuidReplay>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['portalWebhooksPostPortalWebhooksDeliveriesIdGuidReplay'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof portalWebhooksPostPortalWebhooksDeliveriesIdGuidReplay>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return portalWebhooksPostPortalWebhooksDeliveriesIdGuidReplay(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PortalWebhooksPostPortalWebhooksDeliveriesIdGuidReplayMutationResult = NonNullable<
  Awaited<ReturnType<typeof portalWebhooksPostPortalWebhooksDeliveriesIdGuidReplay>>
>;

export type PortalWebhooksPostPortalWebhooksDeliveriesIdGuidReplayMutationError = unknown;

export const usePortalWebhooksPostPortalWebhooksDeliveriesIdGuidReplay = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof portalWebhooksPostPortalWebhooksDeliveriesIdGuidReplay>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof portalWebhooksPostPortalWebhooksDeliveriesIdGuidReplay>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions =
    getPortalWebhooksPostPortalWebhooksDeliveriesIdGuidReplayMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const portalWebhooksPostPortalWebhooksEventsIdGuidReplayFailed = (
  id: string,
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<WebhookEventDetailDto>(
    { url: `/portal/webhooks/events/${id}/replay-failed`, method: 'POST', signal },
    options,
  );
};

export const getPortalWebhooksPostPortalWebhooksEventsIdGuidReplayFailedMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof portalWebhooksPostPortalWebhooksEventsIdGuidReplayFailed>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof portalWebhooksPostPortalWebhooksEventsIdGuidReplayFailed>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['portalWebhooksPostPortalWebhooksEventsIdGuidReplayFailed'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof portalWebhooksPostPortalWebhooksEventsIdGuidReplayFailed>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return portalWebhooksPostPortalWebhooksEventsIdGuidReplayFailed(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PortalWebhooksPostPortalWebhooksEventsIdGuidReplayFailedMutationResult = NonNullable<
  Awaited<ReturnType<typeof portalWebhooksPostPortalWebhooksEventsIdGuidReplayFailed>>
>;

export type PortalWebhooksPostPortalWebhooksEventsIdGuidReplayFailedMutationError = unknown;

export const usePortalWebhooksPostPortalWebhooksEventsIdGuidReplayFailed = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof portalWebhooksPostPortalWebhooksEventsIdGuidReplayFailed>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof portalWebhooksPostPortalWebhooksEventsIdGuidReplayFailed>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions =
    getPortalWebhooksPostPortalWebhooksEventsIdGuidReplayFailedMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const portalWebhooksGetPortalWebhooksEventsIdGuidApiRequests = (
  id: string,
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<LinkedApiRequestDto[]>(
    { url: `/portal/webhooks/events/${id}/api-requests`, method: 'GET', signal },
    options,
  );
};

export const getPortalWebhooksGetPortalWebhooksEventsIdGuidApiRequestsQueryKey = (id?: string) => {
  return [`/portal/webhooks/events/${id}/api-requests`] as const;
};

export const getPortalWebhooksGetPortalWebhooksEventsIdGuidApiRequestsQueryOptions = <
  TData = Awaited<ReturnType<typeof portalWebhooksGetPortalWebhooksEventsIdGuidApiRequests>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof portalWebhooksGetPortalWebhooksEventsIdGuidApiRequests>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPortalWebhooksGetPortalWebhooksEventsIdGuidApiRequestsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof portalWebhooksGetPortalWebhooksEventsIdGuidApiRequests>>
  > = ({ signal }) =>
    portalWebhooksGetPortalWebhooksEventsIdGuidApiRequests(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof portalWebhooksGetPortalWebhooksEventsIdGuidApiRequests>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PortalWebhooksGetPortalWebhooksEventsIdGuidApiRequestsQueryResult = NonNullable<
  Awaited<ReturnType<typeof portalWebhooksGetPortalWebhooksEventsIdGuidApiRequests>>
>;
export type PortalWebhooksGetPortalWebhooksEventsIdGuidApiRequestsQueryError = unknown;

export function usePortalWebhooksGetPortalWebhooksEventsIdGuidApiRequests<
  TData = Awaited<ReturnType<typeof portalWebhooksGetPortalWebhooksEventsIdGuidApiRequests>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof portalWebhooksGetPortalWebhooksEventsIdGuidApiRequests>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof portalWebhooksGetPortalWebhooksEventsIdGuidApiRequests>>,
          TError,
          Awaited<ReturnType<typeof portalWebhooksGetPortalWebhooksEventsIdGuidApiRequests>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePortalWebhooksGetPortalWebhooksEventsIdGuidApiRequests<
  TData = Awaited<ReturnType<typeof portalWebhooksGetPortalWebhooksEventsIdGuidApiRequests>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof portalWebhooksGetPortalWebhooksEventsIdGuidApiRequests>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof portalWebhooksGetPortalWebhooksEventsIdGuidApiRequests>>,
          TError,
          Awaited<ReturnType<typeof portalWebhooksGetPortalWebhooksEventsIdGuidApiRequests>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePortalWebhooksGetPortalWebhooksEventsIdGuidApiRequests<
  TData = Awaited<ReturnType<typeof portalWebhooksGetPortalWebhooksEventsIdGuidApiRequests>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof portalWebhooksGetPortalWebhooksEventsIdGuidApiRequests>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function usePortalWebhooksGetPortalWebhooksEventsIdGuidApiRequests<
  TData = Awaited<ReturnType<typeof portalWebhooksGetPortalWebhooksEventsIdGuidApiRequests>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof portalWebhooksGetPortalWebhooksEventsIdGuidApiRequests>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPortalWebhooksGetPortalWebhooksEventsIdGuidApiRequestsQueryOptions(
    id,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
